import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ReminderPopupRoutingModule } from './reminder-popup-routing.module';
import { ReminderPopupComponent } from './reminder-popup.component';
import { SharedModule } from '../shared.module';


@NgModule({
  declarations: [
    ReminderPopupComponent
  ],
  imports: [
    CommonModule,
    ReminderPopupRoutingModule,
    SharedModule
  ]
})
export class ReminderPopupModule { }
